import { useUserBillingInfo } from '../../data/injected-billing';
import { isMaxBillingSeat } from './is-max-billing-seat';

/**
 * True when billing reports a Max seat on any tier (Clinician Max or Practice Max).
 * Reads the app-injected billing query so billing-dev seat overrides match the plan card.
 */
export function useIsMaxBillingSeat(): boolean {
  const { data: billingInfo } = useUserBillingInfo();
  return isMaxBillingSeat(billingInfo);
}
